import { useEffect } from "react";

/**
 * If browser back button was used, and the page is not newly loaded, execute callback
 * This ensures that user will always see an accurate, up-to-date view based on their state
 * https://stackoverflow.com/questions/8788802/prevent-safari-loading-from-cache-when-back-button-is-clicked
 * https://web.dev/bfcache
 */
export const useOnPersistedPageShow = (callback: () => void) => {
  useEffect(() => {
    window.addEventListener("pageshow", (event: PageTransitionEvent) => {
      if (event.persisted) {
        callback();
      }
    });
  }, [callback]);
};
